import type { SiteMapItem } from "@/config/sitemap";

import type { Module } from "@/types/tenant";

type ModuleGated = Pick<
  SiteMapItem,
  "moduleName" | "moduleNames" | "routeModuleNames"
>;

/**
 * Whether the tenant has what this item, and everything under it, needs:
 * `moduleName` itself and any one of `moduleNames`.
 */
export function itemModulesEnabled(
  item: ModuleGated,
  enabledModules: readonly Module[],
): boolean {
  if (item.moduleName && !enabledModules.includes(item.moduleName)) {
    return false;
  }
  if (
    item.moduleNames?.length &&
    !item.moduleNames.some((module) => enabledModules.includes(module))
  ) {
    return false;
  }
  return true;
}

/** Whether the item's own page opens: its modules plus its `routeModuleNames`. */
export function routeModulesEnabled(
  item: ModuleGated,
  enabledModules: readonly Module[],
): boolean {
  return (
    itemModulesEnabled(item, enabledModules) &&
    (!item.routeModuleNames?.length ||
      item.routeModuleNames.some((module) => enabledModules.includes(module)))
  );
}
